import { useRouter } from 'next/navigation'
import { useSimplePet } from '@/context/SimplePetContext'

export function usePetNavigation() {
  const router = useRouter()
  const { currentPet } = useSimplePet()

  const navigateWithPet = (path: string) => {
    if (currentPet) {
      const separator = path.includes('?') ? '&' : '?'
      router.push(`${path}${separator}petId=${currentPet.id}`)
    } else {
      router.push(path)
    }
  }

  const navigateToHome = () => {
    if (currentPet) {
      router.push(`/owners?petId=${currentPet.id}`)
    } else {
      router.push('/')
    }
  }

  return {
    navigateWithPet,
    navigateToHome,
    hasPet: !!currentPet
  }
}
